// 關鍵地址頁面翻譯
export default {
  // 輸入框佔位符
  placeholders: {
    address: "請輸入地址",
    blockchain: "請選擇主鏈",
    canvas: "請選擇畫布",
  },

  // 按鈕
  buttons: {
    reset: "重置",
    search: "查詢",
    edit: "修改",
    delete: "刪除",
  },

  // 統計信息
  statistics: {
    total: "共計",
    totalData: "條數據",
  },

  // 表格列標題
  table: {
    index: "序號",
    address: "地址",
    blockchain: "公鏈",
    balance: "餘額（折合USDT）",
    remark: "備註",
    relatedCanvas: "關聯畫布",
    creator: "創建人",
    createTime: "創建時間",
    action: "操作",
  },

  // 對話框
  dialogs: {
    title: "刪除確認",
    deleteConfirm: "是否確認刪除該地址?",
  },

  // 提示信息
  messages: {
    noData: "暫無數據",
    deleteSuccess: "刪除成功",
    deleteCancelled: "已取消刪除",
    markSuccess: "標記成功",
    copySuccess: "複製成功",
    loading: "拼命加載中",
  },

  // 確認按鈕
  confirm: {
    ok: "確定",
    cancel: "取消",
  },

  // 編輯備註彈窗
  editDialog: {
    title: "編輯備註",
    label: "備註",
    placeholder: "請輸入修改備註(必填)",
    validation: {
      required: "備註為必填項",
    },
    buttons: {
      reset: "重置",
      confirm: "確認",
    },
    messages: {
      editSuccess: "修改成功",
    },
  },
};
